import React, {useEffect} from 'react';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import EpiContext from '@episerver/spa-core/Spa';
import Config from 'app/Config';
import Image from 'app/Components/Shared/Image/image';

const BitPendingPopupNotification = (props) => {
  const {actions} = useDebtPaymentPopupData();
  return (
    <div>
      <div className='bit-pending-popup-image'>
        <Image src={require('../../images/error.svg')} />
      </div>
      <div className='bit-pending-popup-text'>
        התשלום שלך כבר נמצא בתהליך, אין אפשרות לבחור אמצעי תשלום נוסף. <br /> ניתן להתעדכן בסיומו באפליקציית bit
      </div>

      <BtnSubmit onclick={EpiContext.navigateTo(Config.lobbyUrl)} text={'חזרה לעמוד הראשי'} />
    </div>
  );
};

export default BitPendingPopupNotification;
